// import { gsap } from "gsap";

// const setupMobileMenu = () => {
//   const mobileMenu = document.getElementById("mobile-menu");
//   const menuToggle = document.getElementById("mobile-menu-toggle");
//   const menuClose = document.getElementById("mobile-menu-close");
//   const hamburgerLines = document.querySelectorAll(".hamburger-line");

//   if (menuToggle) {
//     // Set initial ARIA attribute
//     menuToggle.setAttribute("aria-expanded", "false");

//     // Toggle menu and animate hamburger icon
//     menuToggle.addEventListener("click", () => {
//       const isExpanded = menuToggle.getAttribute("aria-expanded") === "true";

//       // Toggle ARIA attribute
//       menuToggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");

//       // Animate hamburger lines
//       hamburgerLines[0].classList.toggle("rotate-45");
//       hamburgerLines[1].classList.toggle("opacity-0");
//       hamburgerLines[2].classList.toggle("-rotate-45");

//       // Open or close the menu
//       if (isExpanded) {
//         gsap.to(mobileMenu, {
//           x: "-100%",
//           duration: 0.3,
//           ease: "power2.inOut",
//         });
//       } else {
//         gsap.to(mobileMenu, {
//           x: 0,
//           duration: 0.3,
//           ease: "power2.inOut",
//         });
//       }
//     });
//   }

//   // Close menu with close button
//   if (menuClose) {
//     menuClose.addEventListener("click", () => {
//       menuToggle.setAttribute("aria-expanded", "false");
//       hamburgerLines[0].classList.remove("rotate-45");
//       hamburgerLines[1].classList.remove("opacity-0");
//       hamburgerLines[2].classList.remove("-rotate-45");

//       gsap.to(mobileMenu, {
//         x: "-100%",
//         duration: 0.3,
//         ease: "power2.inOut",
//       });
//     });
//   }
// };

// // export default setupMobileMenu;
// import { gsap } from "gsap";

// const setupMobileMenu = () => {
//   const mobileMenu = document.getElementById("mobile-menu");
//   const menuToggle = document.getElementById("mobile-menu-toggle");
//   const menuClose = document.getElementById("mobile-menu-close");
//   const hamburgerLines = document.querySelectorAll(".hamburger-line");
//   const mobileBreakpoint = 768;

//   const isMobile = () => window.innerWidth <= mobileBreakpoint;

//   if (menuToggle) {
//     menuToggle.setAttribute("aria-expanded", "false");

//     menuToggle.addEventListener("click", () => {
//       if (!isMobile()) return;

//       const isExpanded = menuToggle.getAttribute("aria-expanded") === "true";

//       menuToggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");

//       hamburgerLines[0].classList.toggle("rotate-45");
//       hamburgerLines[1].classList.toggle("opacity-0");
//       hamburgerLines[2].classList.toggle("-rotate-45");

//       if (isExpanded) {
//         gsap.to(mobileMenu, {
//           x: "-100%",
//           duration: 0.3,
//           ease: "power2.inOut",
//         });
//       } else {
//         gsap.to(mobileMenu, {
//           x: 0,
//           duration: 0.3,
//           ease: "power2.inOut",
//         });
//       }
//     });
//   }

//   if (menuClose) {
//     menuClose.addEventListener("click", () => {
//       if (!isMobile()) return;

//       menuToggle.setAttribute("aria-expanded", "false");
//       hamburgerLines[0].classList.remove("rotate-45");
//       hamburgerLines[1].classList.remove("opacity-0");
//       hamburgerLines[2].classList.remove("-rotate-45");

//       gsap.to(mobileMenu, {
//         x: "-100%",
//         duration: 0.3,
//         ease: "power2.inOut",
//       });
//     });
//   }

//   window.addEventListener("resize", () => {
//     if (window.innerWidth > mobileBreakpoint) {
//       if (mobileMenu) {
//         gsap.set(mobileMenu, { x: "-100%" });
//       }
//       if (menuToggle) {
//         menuToggle.setAttribute("aria-expanded", "false");
//       }
//       if (hamburgerLines) {
//         hamburgerLines[0]?.classList.remove("rotate-45");
//         hamburgerLines[1]?.classList.remove("opacity-0");
//         hamburgerLines[2]?.classList.remove("-rotate-45");
//       }
//     }
//   });
// };

// export default setupMobileMenu;


import { gsap } from "gsap";

const setupMobileMenu = () => {
  const mobileMenu = document.getElementById("mobile-menu");
  const menuToggle = document.getElementById("mobile-menu-toggle");
  const menuClose = document.getElementById("mobile-menu-close");
  const hamburgerLines = document.querySelectorAll(".hamburger-line");
  const mobileBreakpoint = 768;

  const isMobile = () => window.innerWidth <= mobileBreakpoint;

  if (menuToggle) {
    menuToggle.setAttribute("aria-expanded", "false");

    menuToggle.addEventListener("click", () => {
      if (!isMobile()) return;

      const isExpanded = menuToggle.getAttribute("aria-expanded") === "true";

      menuToggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");

      hamburgerLines[0].classList.toggle("rotate-45");
      hamburgerLines[1].classList.toggle("opacity-0");
      hamburgerLines[2].classList.toggle("-rotate-45");

      if (isExpanded) {
        gsap.to(mobileMenu, {
          x: "-100%",
          duration: 0.3,
          ease: "power2.inOut",
        });
      } else {
        gsap.to(mobileMenu, {
          x: 0,
          duration: 0.3,
          ease: "power2.inOut",
        });
      }
    });
  }

  if (menuClose) {
    menuClose.addEventListener("click", () => {
      if (!isMobile()) return;

      menuToggle.setAttribute("aria-expanded", "false");
      hamburgerLines[0].classList.remove("rotate-45");
      hamburgerLines[1].classList.remove("opacity-0");
      hamburgerLines[2].classList.remove("-rotate-45");

      gsap.to(mobileMenu, {
        x: "-100%",
        duration: 0.3,
        ease: "power2.inOut",
      });
    });
  }

  // Close the menu when a navigation item is clicked
  const navItems = document.querySelectorAll("nav a");
  navItems.forEach(item => {
    item.addEventListener("click", () => {
      if (!isMobile()) return;

      // Close the menu by resetting aria-expanded and removing transformations
      menuToggle.setAttribute("aria-expanded", "false");
      hamburgerLines[0].classList.remove("rotate-45");
      hamburgerLines[1].classList.remove("opacity-0");
      hamburgerLines[2].classList.remove("-rotate-45");

      gsap.to(mobileMenu, {
        x: "-100%",
        duration: 0.3,
        ease: "power2.inOut",
      });
    });
  });

  // Reset on window resize
  window.addEventListener("resize", () => {
    if (window.innerWidth > mobileBreakpoint) {
      if (mobileMenu) {
        gsap.set(mobileMenu, { x: "-100%" });
      }
      if (menuToggle) {
        menuToggle.setAttribute("aria-expanded", "false");
      }
      if (hamburgerLines) {
        hamburgerLines[0]?.classList.remove("rotate-45");
        hamburgerLines[1]?.classList.remove("opacity-0");
        hamburgerLines[2]?.classList.remove("-rotate-45");
      }
    }
  });
};

export default setupMobileMenu;
